import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useStore } from './store';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import Dashboard from './pages/Dashboard';
import AcceptInvite from './pages/AcceptInvite';
import Docs from './pages/Docs';
import { CookieConsent } from './components/CookieConsent';

function ExternalRedirect({ to }: { to: string }) {
  window.location.href = to;
  return null;
}

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const user = useStore((state) => state.user);

  // Check localStorage if store doesn't have user yet
  if (!user) {
    const storedUser = localStorage.getItem('user');
    const storedTokens = localStorage.getItem('auth_tokens');

    if (!storedUser || !storedTokens) {
      return <Navigate to="/login" replace />;
    }
  }

  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/invite/:token" element={<AcceptInvite />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/docs/:slug" element={<Docs />} />
        <Route path="/pricing" element={<ExternalRedirect to="https://tahc.ai/pricing" />} />
        <Route
          path="/dashboard/*"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
